/**
 *
 * Button
 *
 */




import React, { useCallback, ReactNode } from 'react';

import { browserHistory } from 'react-router';

import { ButtonProps } from '../ButtonProps';

import ButtonWrapper from './styles/ButtonWrapper';

import {
  buttonTitle
} from './helpers';


function Button({
  value,
  onClick,
  href,
  isDisabled,
  isInternal,
  isSending,
  disabledOnClick,
  hasAlert,
  customLoaderStyling,
  target,
  thisStyles,
  title,
  children,
  buttonName,
  id
} : ButtonProps) {

  const handleClick = onClick ? useCallback((event: React.MouseEvent<HTMLButtonElement>) => {

    if (!hasAlert) {

      if (href && !isInternal || isSending) return;

      event.preventDefault();
      event.stopPropagation();
  
      if (href) return browserHistory.push(href);
  
      if (isDisabled) {
        if (!disabledOnClick) return;
        return disabledOnClick();
      } 
  
      if (onClick) return onClick(value, event);
    }
  }, [onClick, value, disabledOnClick, isDisabled, href, isInternal, isSending]) : null;

  return (
    <ButtonWrapper
      onClick={handleClick}
      as={href ? 'a' : ''}
      href={href}
      $isDisabled={isDisabled}
      target={target}
      $thisStyles={thisStyles}
      className={buttonName ? buttonName : ''}
      id={id}
    >
      {children ? children : buttonTitle(isSending, title, customLoaderStyling)}
    </ButtonWrapper>
  );
}

export default Button;
